import { IDataAccessService } from '@price-for-profit/micro-services';
import { CLIENT_ID, DATABASE_LABEL, SCHEMAS } from 'shared/constants';
import { FutureDeviation, FutureMarketPrice } from 'shared/types';

export interface CancelFuturePriceProps<T extends FutureDeviation | FutureMarketPrice> {
    row: T;
    key: string;
    userId: string;
    userEmail: string;
    userName: string;
    tableId: string;
    schemaName?: string;
}

export interface IFuturePriceService {
    cancelFuturePrice<T extends FutureDeviation | FutureMarketPrice>(props: CancelFuturePriceProps<T>): Promise<void>;
}

export class FuturePriceService implements IFuturePriceService {
    constructor(private dataAccessService: IDataAccessService) { }
    async cancelFuturePrice<T extends FutureDeviation | FutureMarketPrice>(props: CancelFuturePriceProps<T>): Promise<void> {
        await this.executeCancelPatch<T>(props);
        await this.executeDeleteRow<T>(props);
    }

    private async executeDeleteRow<T extends FutureDeviation | FutureMarketPrice>({
        key,
        tableId,
        schemaName = SCHEMAS.DBO
    }: CancelFuturePriceProps<T>): Promise<void> {
        await this.dataAccessService.deleteRow<T, typeof DATABASE_LABEL>({
            clientId: CLIENT_ID,
            databaseLabel: DATABASE_LABEL,
            tableId,
            key,
            schemaName
        });
    }

    private async executeCancelPatch<T extends FutureDeviation | FutureMarketPrice>({
        key,
        tableId,
        userId,
        userEmail,
        userName,
        schemaName = SCHEMAS.DBO
    }: CancelFuturePriceProps<T>): Promise<void> {
        await this.dataAccessService.patchRow<T, typeof DATABASE_LABEL>({
            clientId: CLIENT_ID,
            databaseLabel: DATABASE_LABEL,
            tableId,
            key,
            schemaName,
            operations: [
                {
                    op: 'replace',
                    path: 'isDeleted',
                    value: true
                },
                {
                    op: 'replace',
                    path: 'updatedByEmail',
                    value: userEmail
                },
                {
                    op: 'replace',
                    path: 'updatedByDisplayName',
                    value: userName
                },
                {
                    op: 'replace',
                    path: 'updatedByUserId',
                    value: userId
                },
                {
                    op: 'replace',
                    path: 'updatedReason',
                    value: 'Manually cancelled'
                }
            ]
        });
    }
}
